import axios from "axios";
// const host = "http://localhost:3017";
const host = process.env.VUE_APP_URL_API || "http://192.168.0.6:3017";
// const host = "http://192.168.0.6:3017";
// const host = "https://api.cosmoscode.com.br/stonepro/";
// const host = "https://api.cosmoscode.com.br/stonepro/";
// const host = "https://perfectly-probable-kid.ngrok-free.app";

let http = axios.create({
  baseURL: host,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${
      localStorage.token ? JSON.parse(localStorage.token) : ""
    }`
  }
});

http.interceptors.request.use(
  function(config) {
    config.headers.Authorization = `Bearer ${
      localStorage.token ? JSON.parse(localStorage.token) : ""
    }`;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export default http;
